import type { EventPageVisibility } from '@graphql/generated-base';

/**
 * Reusable utility function for checking if a page is visible
 * A page is considered visible if it's public, password protected, or specificGuests.
 * `specificGuests` counts as visible because callers run guest-side on already
 * access-filtered data — the page is only present when the viewing guest is eligible.
 * Accepts both GraphQL enum values and string literals for compatibility
 */
export const isEventPageVisible = (visibility?: EventPageVisibility | 'hidden' | 'passwordProtected' | 'public' | 'specificGuests') => {
  if (!visibility) return false;
  return visibility === 'public' || visibility === 'passwordProtected' || visibility === 'specificGuests';
};
